import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate, isNullOrEmpty, newObj } from '../../../../../utils/util';
import { getVision } from '../../../../../services/auth';
import { VISIONS, ENUMS } from '../../../../../utils/constants';
import * as actionsLowering from '../../../../../actions/loweringAction';
import { Select, Breadcrumbs } from '../../../../../components/UI/ComponentsUI';
import LoweringService from '../../../../../services/LoweringService';

const SmallPartsFilterByRoute = (props) => {
    const [routeCode, setRouteCode] = useState('');
    const [routeSelect, setrouteSelect] = useState('');
    const [arrayDrop, setArrayDrop] = useState([]);
    const [arrayDropMdrType, setArrayDropMdrType] = useState([]);
    const [filter, setFilter] = useState(props.filterOrder);

    useEffect(() => {
        const filterObj = newObj(props.filterOrder);
        let area = props.areas.find(f => f.code === props.user.unit);
        filterObj.excludeOrderGrouped = true;
        filterObj.routeCode = null;
        filterObj.routes = [];
        filterObj.mdrTypeList = [];
        if (area) {
            filterObj.areaRouteAreaId = area.unitId;
        }
        filterObj.sectors = props.sectors;
        filterObj.orderType = ENUMS.eOrderType.Lowering.value;
        filterObj.routeType = ENUMS.eRouteType.Lowering.value;
        props.getRoutes(filterObj, (data) => {
            var drop = data.map((i) => {
                return { id: i.code, text: i.code, mdrTypes: i.mdrList };
            });

            const sortedDrop = drop.sort((a, b) => {
                if (a.text < b.text) { return -1; }
                if (a.text > b.text) { return 1; }
                return 0;
            });

            setArrayDrop(sortedDrop);
        });
        // eslint-disable-next-line
    }, []);

    const onChangeRoute = (event) => {
        if (event.currentTarget.options[event.currentTarget.selectedIndex]) {
            var routecode = event.currentTarget.options[event.currentTarget.selectedIndex].text || '';
            setrouteSelect(event.currentTarget.value);
            setRouteCode(routecode);
            var mdrTypes = arrayDrop.find(i => i.id === routecode)?.mdrTypes || '';
            if (mdrTypes) {
                setArrayDropMdrType(mdrTypes.map((i) => {
                    return { id: i, text: i };
                }));
            }
            else {
                setArrayDropMdrType([]);
            }
        }
    }

    const applyFilter = () => {
        if (!isNullOrEmpty(routeCode) || filter.routes.length > 0) {
            props.filter.routeCode = routeCode;
            props.filter.routes = filter.routes;
            props.filter.dynamicFlow = false;
            props.filter.mdrTypeList = filter.mdrTypes;
            if ((getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
                props.filter.orderType = ENUMS.eOrderType.Lowering.value;
                props.filter.excludeOrderGrouped = true;
                props.filter.unitOrderingId = props.areas.find((a) => a.code === props.almox)?.unitOrderingId;
                props.filter.sectors = props.sectors;
                props.filter.allOrders = true;
                props.setFilterOrder(props.filter);

                // Redirect para tela de Orders
                props.history.push({
                    pathname: '../orders',
                    state: {
                        printerLabel: true,
                        kanban: true
                    }
                });
            }
            else {
                var obj = {};
                Object.assign(obj, props.filter);
                obj.unitOrderingId = props.areas.find((a) => a.code === props.almox)?.unitOrderingId;
                props.setFilterOrder(obj);
                // Redirect para tela de Orders
                props.history.push({
                    state: {
                        filterRoute: true
                    },
                    pathname: '../onDemand'
                });

            }
        }
    };


    const subtitlesSmallPartsFilterByRoute = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('line-picking:linepicking.filterByRoute') }];
    }

    const addRouteAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.routes.push(item)
            setFilter(finalFilter);
        }
    };

    const addRouteFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        if (selectedOptions.length > 0) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.routes = Array.from(selectedOptions).map(x => x.value)
            setFilter(finalFilter);
        }
    };

    const addMdrTypeAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.mdrTypes.push(item)
            setFilter(finalFilter);
        }
    };

    const addMdrTypeFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        if (selectedOptions.length > 0) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.mdrTypes = Array.from(selectedOptions).map(x => x.value)
            setFilter(finalFilter);
        }
    };

    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrder" subtitles={subtitlesSmallPartsFilterByRoute()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">{
                    (getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) ? (
                        <div>
                            <div className="col s12">
                                <Select
                                    required
                                    id="route"
                                    label="Rota"
                                    name="route"
                                    display="description"
                                    change={onChangeRoute}
                                    //defaultValue={routeSelect}
                                    placeHolder={translate('general:choose-one-option')}
                                    data={arrayDrop}
                                />
                            </div>
                            {arrayDropMdrType && arrayDropMdrType.length > 0 &&
                                <div className="col s12">
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            required
                                            id="mdrTypes"
                                            label="Mdr"
                                            name="mdrTypes"
                                            display="description"
                                            change={addMdrTypeFilter}
                                            multiple={true}
                                            changeAll={addMdrTypeAll}
                                            placeHolder={translate('general:choose-one-option')}
                                            disablePlaceHoderSelect={true}
                                            data={arrayDropMdrType}

                                            clearAll={() => {
                                                filter.mdrTypes = [];
                                                setFilter({ ...filter });
                                            }}
                                        />
                                    </div>
                                </div>
                            }
                        </div>

                    ) : (
                        <div>
                            <div className="col s12">
                                <div className="input-field no-padding col s12">
                                    <Select
                                        id="route"
                                        name="route"
                                        display="description"
                                        change={addRouteFilter}
                                        multiple={true}
                                        changeAll={addRouteAll}
                                        placeHolder={translate('general:choose-one-option')}
                                        disablePlaceHoderSelect={true}
                                        data={arrayDrop}
                                        clearAll={() => {
                                            filter.position = [];
                                            setFilter({ ...filter });
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    )
                }
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3
                        btn
                        btn-principal
                        waves-effect
                        waves-light"
                        onClick={() => applyFilter()}
                    >
                        {translate('apply', 'general')}
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.loweringReducer.filter,
        sectors: state.loweringReducer.sectors,
        routes: state.pickingReducer.routes,
        almox: state.loweringReducer.almox,
        areas: state.loweringReducer.areas,
        filterOrder: state.loweringReducer.filter,
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrder: (filter) => {
            dispatch(actionsLowering.setFilter(filter));
        },
        getRoutes: (filter, callback) => {
            dispatch(LoweringService.getRoutes(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilterByRoute)));
